import { Injectable } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "src/environments/environment";
import { lastValueFrom } from "rxjs";
import { Caja } from "src/app/models/administracion/caja.model";

@Injectable({
    providedIn: 'root'
})
export class CajaService extends BaseService {
    
    override recordName = 'cajas';

    override url = `${ environment.host }/caja`;

    async buscarCaja( body?: Record<string, any>) {      
        let url = `${this.url}/buscar-caja`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url, body, { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async cajasDisponibles( filtros: Record<string, any>) {      
        let url = `${this.url}/cajas-disponibles`;
        try {
            await this.updateToken();
            const headers = this.header;
            const resp = await lastValueFrom(this.http.post<any>(url,  { filtros: filtros } , { headers: headers }));
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
}